export default __webpack_public_path__ + "static/media/in-person-facilitation.97c22f0f.svg";